export class Search {
    column: string;
    content: any;

    constructor(column?: string, content?: any) {
        this.column = column;
        this.content = content;
    }
}
